export interface PasswordValidation {
  minLength: boolean;
  hasUpper: boolean;
  hasNumber: boolean;
  isValid: boolean;
}

/**
 * Validates a password against security requirements:
 * - Minimum 8 characters
 * - At least one uppercase letter
 * - At least one number
 */
export const validatePassword = (password: string): PasswordValidation => {
  const minLength = password.length >= 8;
  const hasUpper = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  
  return {
    minLength,
    hasUpper,
    hasNumber,
    isValid: minLength && hasUpper && hasNumber
  };
};

/**
 * Returns a German error message based on validation results
 */
export const getPasswordErrorMessage = (validation: PasswordValidation): string | null => {
  if (!validation.minLength) {
    return 'Das Passwort muss mindestens 8 Zeichen lang sein.';
  }
  if (!validation.hasUpper) {
    return 'Das Passwort muss mindestens einen Großbuchstaben enthalten.';
  }
  if (!validation.hasNumber) {
    return 'Das Passwort muss mindestens eine Zahl enthalten.';
  }
  return null;
};
